export function AnalyticsDictFactory(array: any[]) {
  const dict: any = {};

  array.forEach((value, index: number) => {
    dict[`index_${index}`] = value;
  });

  return dict;
}
